import _msp_interfaces from './interfaces.js';

const constructors = {}

// NOTA: constructors.Test è stato rimosso (nessun call site nel repo, grep verificato).

// NOTA: chiamata sempre senza argomenti in tutto il repo (grep verificato) — i costruttori
// di questo file la usano solo per generare un id nuovo, mai per normalizzarne uno esistente.
// C'era in passato un ramo "gestisci un id passato" duplicato (e divergente) da _funzioni.unique
// in funzioni.js: rimosso qui perché morto, resta l'unico caso realmente usato.
constructors.unique = function() {
  return +new Date() + 1;
}


constructors.getDefaultUmFromUms = function (ums) {
  if (ums && ums.length) {
    return ums[0].um_id;
  }
  return undefined;
}


// La zona di default (Z1 per corsa/ciclismo/sci, A1 per nuoto) viene assegnata
// in MspAndatura.setDefaultZona(), non qui: il costruttore non ha visibilità
// sull'array delle zone del prop `zone`, disponibile solo nel componente.
constructors.Andatura = function(id, ums) {
  if(typeof id === 'undefined') {
    id = constructors.unique();
  }

  var a = {
    'id': id,
    'hms': '00:00:00',
    'val_andatura': 0,
    'um_id': constructors.getDefaultUmFromUms(ums),
    'des_zona': '',
  }
  return a;
}
constructors.Serie = function(id, ums) {
  if(typeof id === 'undefined') {
    id = constructors.unique();
  }
  var a = {
    'ripetute': 1,
    'andature': [],
  }
  a.andature.push(constructors.Andatura(undefined, ums));
  return a;
}

// NOTA: esisteva un ramo alternativo per sport_id===ID_PALESTRA con shape diversa
// (categoria/esercizio invece di serie), ma confrontava con `constructors.ID_PALESTRA`
// mai definito (sempre NaN) → non scattava mai. Rimosso: Palestra/Scheda.vue usa comunque
// `dettaglio.serie` come tutti gli altri sport, quindi la shape generica è quella corretta.
constructors.Dettaglio = function (sport_id, ums) {
  return {
    'id': constructors.unique(),
    'ums': [],
    // Default 'Lavoro' (stessa dicitura di fase_allenamento.json/des_fasi e di
    // makeDettagliDefaultBySport() lato backend): prima era '', per cui una fase
    // aggiunta dall'editor restava senza descrizione finché non la si sceglieva a mano.
    'des_attivita': 'Lavoro',
    'serie': [
      constructors.Serie(undefined, ums)
    ],
    'totale': Object.assign({},_msp_interfaces.totale())
  }
}

constructors.Risultato = function () {
  var risultato =  {
    "calcolato":"",
    "data":"",
    "atleta_id":"",
    "sport_id":"",
    "id_test":"",
    "id_test_atleta":"",
    "id_tipo":"",
    "is_active":"",
    "nome":"",
    "note_test":null,
    "passo":"",
    "ranking":"",
    "risultato":"",
    "fc_max":"",
    "fc_media":"",
    "sport":"",
    "um":"",
    "zone":"",
  }
  return risultato;
}


constructors.Informazioni = function () {
  return {
    'zone':[],
    'zone_risultati': null,
    'densita': 0,
    'mets':[],
    'trimps':[],
    'workload':[],
    'trimp':[],
    'totale':[],
    'ums': []

  }
}


export { constructors as default};
